import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import styles from './MileageSaarathi.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import "../style.css"
import moment from 'moment';
import ChartLoader from './Loader_MS_bus';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";


const DrivingBehaviorTable = forwardRef(({ filterdata, setExpertInsightLoading }, ref) => {
    const [tableData, setTableData] = useState([])
    const [totalInstanceTableData, setTotalInstanceTableData] = useState([])

    const [totalVehicleModalData, setTotalVehicleModalData] = useState([])
    const [totalInstanceModalData, setTotalInstanceModalData] = useState([])


    const { isLoading, error, sendReq: fetchData } = useHttp();


    useEffect(() => {
        setExpertInsightLoading(true)
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/Driving_behaviour_total_vehicles`,
                body: { filterdata }
            },
            (data) => {
                setTableData(data)
                setExpertInsightLoading(false)
            }
        );

        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/Driving_behaviour_total_instances`,
                body: { filterdata }
            },
            (data) => {
                setTotalInstanceTableData(data)
            }
        );
    }, [filterdata])

    const getTotalVehicleModalData = () => {
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/Driving_behaviour_total_vehicles_vehicle_wise`,
                body: { filterdata }
            },
            (data) => {
                let modalData = data?.vehicles
                setTotalVehicleModalData(modalData)
            }
        );
    }

    const getTotalInstanceModalData = () => {
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/Driving_behaviour_total_instances_vehicle_wise`,
                body: { filterdata }
            },
            (data) => {
                let modalData = data?.groupby?.buckets
                setTotalInstanceModalData(modalData)
            }
        );
    }

    useImperativeHandle(ref, () => ({
        downloadData: () => {
            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const excelFileName = "Driving Behavior Report";

            const flatData = [{
                'Total Vehicles': tableData?.Total_Vehicles.value,
                'Coasting': tableData?.Costing?.hours + " hrs " + tableData?.Costing?.minutes + " mins",
                "Regeneration": tableData?.Regeneration?.hours + " hrs " + tableData?.Regeneration?.minutes + " mins",
                "Idling": tableData?.Idling?.hours + " hrs " + tableData?.Idling?.minutes + " mins",
                "Drive Duration": tableData?.DriveDuration?.hours + " hrs " + tableData?.DriveDuration?.minutes + " mins",
            }];

            const ws = XLSX.utils.json_to_sheet(flatData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);

        }
    }))

    return (
        <>
            <div className={`table-responsive mb-4 ${styles.driver_behaviour}`}>
                <table className="table table-hover table-bordered m-0">
                    <thead>
                        <tr className={styles.driver_behaviour_tablerow}>
                            <th className="fw-bold">Total Vehicles</th>
                            <th className="fw-bold">Coasting</th>
                            <th className="fw-bold">Regeneration</th>
                            <th className="fw-bold">Idling</th>
                            <th className="fw-bold">Drive Duration</th>
                            <th className="fw-bold">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? <tr><td colSpan={6} className='text-center table-cell' >Loading...</td></tr>
                            : Object.keys(tableData)?.length ?
                                <tr className={styles.driver_behaviour_tablerowstyle}>
                                    <td>{tableData?.Total_Vehicles?.value ? tableData.Total_Vehicles?.value : "--"}</td>
                                    <td>{tableData?.Costing?.hours + " hrs " + tableData?.Costing?.minutes + " mins"}</td>
                                    <td>{tableData?.Regeneration?.hours + " hrs " + tableData?.Regeneration?.minutes + " mins"}</td>
                                    <td>{tableData?.Idling?.hours + " hrs " + tableData?.Idling?.minutes + " mins"}</td>
                                    <td>{tableData?.DriveDuration?.hours + " hrs " + tableData?.DriveDuration?.minutes + " mins"} </td>
                                    <td>
                                        <button className="btn btn-sm btn-outline-info ms_btn MS_button" data-toggle="modal" data-target={"#totalVehicleModalData"} onClick={() => getTotalVehicleModalData()}>
                                            View Details
                                        </button>
                                    </td>
                                </tr> : <tr><td colSpan={6} className='text-center table-cell' > No Data found</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className={`table-responsive ${styles.driver_behaviour}`}>
                <table className="table table-hover table-bordered m-0">
                    <thead>
                        <tr className={styles.driver_behaviour_tablerow}>
                            <th className="fw-bold">Total Instances</th>
                            <th className="fw-bold">Harsh Acceleration</th>
                            <th className="fw-bold">Harsh Braking</th>
                            <th className="fw-bold">Rash Turning</th>
                            <th className="fw-bold">Overspeeding</th>
                            <th className="fw-bold">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? <tr><td colSpan={6} className='text-center table-cell' >Loading...</td></tr>
                            : Object.keys(totalInstanceTableData).length ?
                                <tr className={styles.driver_behaviour_tablerowstyle}>
                                    <td>
                                        {
                                            (totalInstanceTableData?.Harsh_Acceleration?.value || 0) +
                                            (totalInstanceTableData?.Harsh_Braking?.value || 0) +
                                            (totalInstanceTableData?.Rash_Turning?.value || 0) +
                                            (totalInstanceTableData?.Over_Speeding?.value || 0)
                                        }
                                    </td>
                                    <td>{totalInstanceTableData?.Harsh_Acceleration?.value}</td>
                                    <td>{totalInstanceTableData?.Harsh_Braking?.value}</td>
                                    <td>{totalInstanceTableData?.Rash_Turning?.value}</td>
                                    <td>{totalInstanceTableData?.Over_Speeding?.value}</td>
                                    <td>
                                        <button className="btn btn-sm btn-outline-info ms_btn MS_button" data-toggle="modal" data-target={"#totalInstanceModalData"} onClick={() => getTotalInstanceModalData(true)}>
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                                : <tr><td colSpan={6} className='text-center table-cell' > No Data found</td></tr>
                        }
                    </tbody>
                </table>

                <div>
                    <div id="totalVehicleModalData" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal">
                                        &times;
                                    </button>
                                </div>

                                <div className="modal-body p-0" style={{ overflowY: "scroll", height: "350px", }}>
                                    <table className="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr style={{ backgroundColor: '#83a4cf', color: '#fff', position: 'sticky', top: 0 }}>
                                                <th>Sr. No.</th>
                                                <th>Vehicle Details</th>
                                                <th>Idling</th>
                                                <th>Regeneration</th>
                                                <th>Coasting</th>
                                                <th>Drive Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? <ChartLoader />
                                                : totalVehicleModalData?.length ?
                                                    totalVehicleModalData.map((data, i) => (
                                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                            <td>{i + 1}</td>
                                                            <td>{data?.vehicleId}</td>
                                                            <td>{data?.Idling?.hours + " hrs " + data?.Idling?.minutes + " mins"}</td>
                                                            <td>{data?.Regeneration?.hours + " hrs " + data?.Regeneration?.minutes + " mins"}</td>
                                                            <td>{data?.Costing?.hours + " hrs " + data?.Costing?.minutes + " mins"}</td>
                                                            <td>{data?.DriveDuration?.hours + " hrs " + data?.DriveDuration?.minutes + " mins"}</td>
                                                        </tr>
                                                    )) : <tr><td colSpan={6} className='text-center table-cell' > No Data found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                                        CLOSE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div id="totalInstanceModalData" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {/* <h4 className="modal-title text-capitalize">{"title"}</h4> */}
                                    <button type="button" className="close" data-dismiss="modal">
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body p-0" style={{ overflowY: "scroll", height: "350px", }}>
                                    <table className="table table-bordered table-hover mb-0">
                                        <thead>
                                            <tr style={{ backgroundColor: '#83a4cf', color: '#fff', position: 'sticky', top: 0 }}>
                                                <th>Sr. No.</th>
                                                <th>Vehicle Details</th>
                                                <th>Harsh Acceleration</th>
                                                <th>Harsh Braking</th>
                                                <th>Rash Turning</th>
                                                <th>Overspeeding</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                isLoading ? <ChartLoader /> :
                                                    totalInstanceModalData?.length ?
                                                        totalInstanceModalData?.map((data, i) => (
                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                <td>{i + 1}</td>
                                                                <td>{data.key?.vehicleId}</td>
                                                                <td>{data?.Harsh_Acceleration?.value}</td>
                                                                <td>{data?.Harsh_Braking?.value}</td>
                                                                <td>{data?.Rash_Turning?.value}</td>
                                                                <td>{data?.Over_Speeding?.value}</td>
                                                            </tr>
                                                        )) : <tr><td colSpan={6} className='text-center table-cell' > No Data found</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                                        CLOSE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
})

export default DrivingBehaviorTable
